var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.0026L0.848528 11.1456L12.7279 23.143L11.8794 24L0 12.0026Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.848511 12.8544L-1.74634e-05 11.9974L11.8794 1.07942e-05L12.7279 0.856968L0.848511 12.8544Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.4867L1.19995 12.4867L1.19995 11.2748L24 11.2748L24 12.4867Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCAxMi4wMDI2TDAuODQ4NTI4IDExLjE0NTZMMTIuNzI3OSAyMy4xNDNMMTEuODc5NCAyNEwwIDEyLjAwMjZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMC44NDg1MTEgMTIuODU0NEwtMS43NDYzNGUtMDUgMTEuOTk3NEwxMS44Nzk0IDEuMDc5NDJlLTA1TDEyLjcyNzkgMC44NTY5NjhMMC44NDg1MTEgMTIuODU0NFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjQgMTIuNDg2N0wxLjE5OTk1IDEyLjQ4NjdMMS4xOTk5NSAxMS4yNzQ4TDI0IDExLjI3NDhMMjQgMTIuNDg2N1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
export { ForwardRef as ReactComponent };